// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 11-observability.md#per-app-metrics-persistence
// @greenlight-spec: 06-agent-interface.md
// @greenlight-spec: 17-code-organization.md
import { initContract } from '@ts-rest/core';
import { AppMetricsSchema, AppMetricsSeriesQuerySchema, AppMetricsSeriesSchema, } from '@greenlight/shared';
import { AppIdParamsSchema, errorResponses } from './common.js';
const c = initContract();
export const metricsContract = c.router({
    getLatest: {
        method: 'GET',
        path: '/api/apps/:id/metrics',
        pathParams: AppIdParamsSchema,
        responses: {
            200: AppMetricsSchema,
            ...errorResponses,
        },
        summary: 'Latest 1-minute per-app sample (CPU %, memory MB, restart count, requests/min, 4xx/5xx error percent). The REST mirror of the MCP getMetrics tool, reusing the same query service; every field is null until a sample has been collected.',
    },
    getSeries: {
        method: 'GET',
        path: '/api/apps/:id/metrics/series',
        pathParams: AppIdParamsSchema,
        query: AppMetricsSeriesQuerySchema,
        responses: {
            200: AppMetricsSeriesSchema,
            ...errorResponses,
        },
        summary: 'Downsampled per-app history for one metric (cpu|memory) over an explicit from/to window at a 1m/5m/1h step. date_bin-bucketed averages over the persisted samples plus min/max/avg/p95 over the raw samples. The REST mirror of the MCP getMetricsSeries tool; empty points (not an error) when no samples fall in range.',
    },
});
//# sourceMappingURL=metrics.js.map